import React from 'react';
import ReactGA from 'react-ga4';

const Content = () => {
  return (
    <>
      <div className="popup-content-title">
        <h3>South Melbourne – Normanby Road</h3>
      </div>
      <div className="popup-content-source">
        <p>
          <span className="bold">
            Every day, we’re maintaining and upgrading the pipes and pumps that
            keep water flowing. We’re planning to renew the existing water main
            on Normanby Road, South Melbourne between Boundary Street and
            Montague Street.
          </span>
        </p>
        <p>
          We’ve awarded the construction of the water main renewal to our
          industry partner Beca, Fulton Hogan and Interflow (BFHI). We expect
          construction to begin in early February for approximately 17 weeks.
        </p>
        <p>
          For more information click{' '}
          <a
            href="https://southeastwater.com.au/faults-and-works/works/planned-works/suburb-street23/"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: `Map – Major Projects (orange)`,
                action: '<a href> link',
                label: 'MORE INFO: South Melbourne - Normanby Road',
              });
            }}
          >
            here
          </a>{' '}
          or contact the project team at{' '}
          <a href="tel:1800814900">1800 814 900</a> |{' '}
          <a
            href="mailto:renewals@sew.com.au"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: `Map - Major Projects (orange)`,
                action: 'Email link',
                label:
                  'MAIL TO: engagement@sew.com.au: South Melbourne - Normanby Road',
              });
            }}
          >
            renewals@sew.com.au
          </a>
        </p>
      </div>
    </>
  );
};

export default Content;
